import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Allowed email addresses (must match Login.jsx)
const ALLOWED_EMAILS = [
  'mail.trillionstockresearch@gmail.com',
  'vishsoni300@gmail.com'
];

// Utility functions for cookie management
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuthStatus = () => {
      // Check for auth token in cookies
      const authToken = getCookie('authToken');
      
      // Check for employee data in localStorage
      const employeeData = localStorage.getItem('employeeData');
      
      // Check for Firebase auth in sessionStorage
      const firebaseAuth = sessionStorage.getItem('firebaseAuth');
      const firebaseUser = sessionStorage.getItem('firebaseUser');
      
      // If any authentication method is present, user is authenticated
      if ((authToken && employeeData) || (firebaseAuth && firebaseUser)) {
        try {
          let userEmail = null;
          
          // Get email from employee data or Firebase user
          if (employeeData) {
            const data = JSON.parse(employeeData);
            userEmail = data.email;
          } else if (firebaseUser) {
            const user = JSON.parse(firebaseUser);
            userEmail = user.email;
          }
          
          // Check if email is in allowed list
          if (userEmail && !ALLOWED_EMAILS.includes(userEmail)) {
            // Clear all authentication data
            if (localStorage.getItem('employeeData')) {
              localStorage.removeItem('employeeData');
            }
            deleteCookie('authToken');
            if (sessionStorage.getItem('firebaseAuth')) {
              sessionStorage.removeItem('firebaseAuth');
            }
            if (sessionStorage.getItem('firebaseUser')) {
              sessionStorage.removeItem('firebaseUser');
            }
            setIsAuthenticated(false);
            setIsLoading(false);
            return;
          }
          
          setIsAuthenticated(true);
        } catch (error) {
          // If employee data is corrupted, clear it
          if (employeeData) {
            localStorage.removeItem('employeeData');
          }
          if (firebaseAuth) {
            sessionStorage.removeItem('firebaseAuth');
            sessionStorage.removeItem('firebaseUser');
          }
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
      
      setIsLoading(false);
    };

    checkAuthStatus();
  }, []);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
        color: '#fff',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated, and pass the current location as state
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render the protected component if authenticated
  return children;
}

export default ProtectedRoute;
